import * as React from 'react'

import Icon from 'components/Icon'
import { LOGO } from 'Icon/logo'

import './StatusCode.scss'

interface StatusCodeProps {
  code: number
}

const StatusCode: React.FC<StatusCodeProps> = props => {
  return (
    <h1 className={`srprs-status-code`}>
      {/* Wrapper can be every element */}
      {props.code === 404 && (
        <React.Fragment>
          <span>4</span>
          <Icon icon={LOGO.symbol} />
          <span>4</span>
        </React.Fragment>
      )}
      {props.code === 500 && (
        <React.Fragment>
          <span>5</span>
          <Icon icon={LOGO.symbol} />
          <Icon icon={LOGO.symbol} />
        </React.Fragment>
      )}
    </h1>
  )
}

export default StatusCode
